module.exports = __webpack_public_path__ + "img/sld_mfm_inv_12_t1_b1_dark.e8ac84af.svg";